var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Bluebird from "bluebird";
import CacheService from './Cache';
import SecuredDataApi from "../asset/securedDataWithMetaData";
var errors = require("asset/errors");
import sessionService from "./session.service";
var initService = require("services/initService");
import trustManager, { trustStates, transformLegacy, TrustStore, userToDataSet, TRUST_SECURED_OPTIONS, } from "../crypto/trustManager";
import MutableObjectLoader, { SYMBOL_UNCHANGED } from "../services/mutableObjectLoader";
import socketService from "../services/socket.service";
import userService from "../users/userService";
var signatureCache = require("crypto/signatureCache");
var debug = require("debug");
var STORESIGNATURECACHEINTERVAL = 30000;
var debugName = "whispeer:trustService";
var trustServiceDebug = debug(debugName);
function time(name) {
    if (debug.enabled(debugName)) {
        console.time(name);
    }
}
function timeEnd(name) {
    if (debug.enabled(debugName)) {
        console.timeEnd(name);
    }
}
var loadTrustInfo = function (data) {
    return userService.getOwnAsync().then(function (ownUser) {
        var ownKey = ownUser.getSignKey();
        if (!data) {
            var userid = ownUser.getID();
            var nickname = ownUser.getNickname();
            return {
                nicknames: (_a = {},
                    _a[nickname] = ownKey,
                    _a),
                ids: (_b = {},
                    _b[userid] = ownKey,
                    _b),
                me: ownKey,
                keys: (_c = {},
                    _c[ownKey] = userToDataSet({ key: ownKey, userid: userid, nickname: nickname }, trustStates.OWN),
                    _c),
                signature: ""
            };
        }
        if (data.me !== ownKey) {
            throw new errors.SecurityError("not my trust database");
        }
        var givenDatabase = SecuredDataApi.load(undefined, data, TRUST_SECURED_OPTIONS);
        return givenDatabase.verifyAsync(ownKey, "user")
            .then(function () { return transformLegacy(givenDatabase.metaGet()); });
        var _a, _b, _c;
    });
};
var signatureCacheObject = new CacheService("signatureCache");
var TrustService = /** @class */ (function () {
    function TrustService() {
        this.storeSignatureCache = function () {
            if (signatureCache.isChanged()) {
                trustServiceDebug("Storing signature cache!");
                time("storedSignatureCache");
                signatureCache.resetChanged();
                signatureCache.getUpdatedVersion().then(function (updatedVersion) {
                    return signatureCacheObject.store(sessionService.getUserID().toString(), updatedVersion);
                }).then(function () {
                    timeEnd("storedSignatureCache");
                });
            }
        };
        window.setInterval(this.storeSignatureCache, STORESIGNATURECACHEINTERVAL);
        this.waitForLogin();
    }
    TrustService.prototype.waitForLogin = function () {
        sessionService.awaitLogin().then(function () {
            time("getSignatureCache");
            return signatureCacheObject.get(sessionService.getUserID().toString()).catch(function () {
                return;
            });
        }).then(function (signatureCacheData) {
            timeEnd("getSignatureCache");
            if (signatureCacheData) {
                signatureCache.load(signatureCacheData.data);
            }
            else {
                signatureCache.initialize();
            }
        });
    };
    return TrustService;
}());
var TrustStoreLoader = /** @class */ (function (_super) {
    __extends(TrustStoreLoader, _super);
    function TrustStoreLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TrustStoreLoader;
}(MutableObjectLoader({
    download: function (_id, previousInstance) {
        return socketService.awaitConnection()
            .then(function () { return socketService.definitlyEmit("trustManager.get", {
            responseKey: "content",
            cacheSignature: previousInstance && previousInstance.getSignature()
        }); })
            .then(function (response) { return response.content; });
    },
    load: function (response, previousInstance) {
        if (previousInstance && response.unChanged) {
            return Bluebird.resolve(SYMBOL_UNCHANGED);
        }
        return loadTrustInfo(response.content);
    },
    restore: function (content, previousInstance) {
        if (previousInstance) {
            previousInstance.update(content);
            return previousInstance;
        }
        return new TrustStore(content);
    },
    shouldUpdate: function () { return Bluebird.resolve(true); },
    getID: function () { return sessionService.getUserID(); },
    cacheName: "trustStore"
})));
initService.registerCallback(function () {
    return TrustStoreLoader.get(sessionService.getUserID())
        .then(function (trustStore) { return trustManager.setTrustStore(trustStore); });
});
new TrustService();



//////////////////
// WEBPACK FOOTER
// ./js/services/trust.service.ts
// module id = llow
// module chunks = 1 2